module.exports = __webpack_public_path__ + "img/user_guide.6b7594e0.png";